import { CSSProperties, FC } from 'react'
import { List, ListItem } from './style'
import { MuscleLabelInfo } from '@entities/muscle'
import { TextColorForBackground } from '@entities/muscle/config/colors'

export const MusclesLabels: FC<{
	muscleGroups: MuscleLabelInfo[]
	style?: CSSProperties
	itemStyle?: CSSProperties
	itemClass?: string
	className?: string
	columnGap?: number
}> = ({ muscleGroups, style, itemStyle, itemClass, columnGap, className }) => {
	return (
		<List
			style={{
				...style,
				columnGap: columnGap || 'auto',
			}}
			className={className}>
			{muscleGroups.map((muscleGroup, index) => {
				return (
					<ListItem
						key={index}
						className={itemClass}
						style={{
							...itemStyle,
							color: TextColorForBackground[muscleGroup.backgroundColor] || '#fff',
							background: muscleGroup.backgroundColor,
						}}>
						{muscleGroup.name}
					</ListItem>
				)
			})}
		</List>
	)
}
